import { useEffect, useState } from "react";

import Api from "../api/api";
import { resetSessionId } from "../helpers/session";

const MAX_STATUS_CHECKS = 8;
const STATUS_CHECK_DELAY = 1000;

function removeCheckoutParameters() {
  const url = new URL(window.location.href);
  url.searchParams.delete("checkout");
  url.searchParams.delete("checkout_session_id");
  window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
}

export default function useCheckoutResult(search) {
  const [checkoutStatus, setCheckoutStatus] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const checkout = searchParams.get("checkout");
    const checkoutSessionId = searchParams.get("checkout_session_id");
    let cancelled = false;
    let timeoutId;
    let paymentConfirmed = false;

    if (checkout === "cancel") {
      setCheckoutStatus("cancel");
      return undefined;
    }

    if (checkout !== "success") {
      setCheckoutStatus(null);
      return undefined;
    }

    if (!checkoutSessionId) {
      setCheckoutStatus("processing");
      return undefined;
    }

    setCheckoutStatus("verifying");

    async function verifyCheckout(attempt = 1) {
      try {
        const result = await Api.getCheckoutStatus(checkoutSessionId);
        if (cancelled) return;

        if (result?.state === "confirmed") {
          resetSessionId();
          window.dispatchEvent(new Event("cart-updated"));
          setCheckoutStatus("success");
          removeCheckoutParameters();
          return;
        }

        if (result?.state === "processing") {
          paymentConfirmed = true;
        }

        if (result?.state === "unpaid") {
          setCheckoutStatus("error");
          return;
        }
      } catch (error) {
        if (cancelled) return;
        console.error("Unable to verify checkout:", error);
      }

      if (attempt < MAX_STATUS_CHECKS) {
        timeoutId = window.setTimeout(
          () => verifyCheckout(attempt + 1),
          STATUS_CHECK_DELAY
        );
      } else {
        setCheckoutStatus(paymentConfirmed ? "processing" : "error");
      }
    }

    verifyCheckout();

    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, [search]);

  return checkoutStatus;
}
